import { createRouter, createWebHistory } from "vue-router";

import HomeView from "@/views/HomeView.vue";
import CartView from "@/views/CartView.vue";
import ProductsView from "@/views/ProductsView.vue";
import OrdersView from "@/views/OrdersView.vue";
import OrderDetailsView from "@/views/OrderDetailsView.vue";

const routes = [
  {
    path: "/",
    component: HomeView,
  },
  {
    path: "/products",
    component: ProductsView,
  },
  {
    path: "/orders",
    component: OrdersView,
  },
  {
    path: "/orderdetails",
    component: OrderDetailsView,
  },
  {
    path: "/cart",
    component: CartView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL),
  routes,
});

export default router;
